import IAuth, {IUserDetails} from 'models/Auth'
import {fetchUserDetails} from 'utils/api/auth/userService'
import * as authHelper from 'utils/helpers/authHelper'

type OrgIdSource = Partial<IAuth> &
 Partial<IUserDetails> & {
  data?: Partial<IUserDetails> | null
  organisation_id?: number | string
 }

const toOrgId = (value: unknown): number | null => {
 const id = Number(value)
 return Number.isFinite(id) && id > 0 ? id : null
}

export const extractOrganisationId = (
 source?: OrgIdSource | null
): number | null => {
 if (!source) return null

 const nested =
  source.data &&
  typeof source.data === 'object' &&
  !Array.isArray(source.data)
   ? source.data
   : null

 return (
  toOrgId(source.organisationId) ??
  toOrgId(source.organisation_id) ??
  toOrgId(nested?.organisationId) ??
  toOrgId(
   (nested as {organisation_id?: number | string} | null)
    ?.organisation_id
  )
 )
}

const persistOrganisationId = (organisationId: number) => {
 const current = authHelper.getAuth() as
  | (Partial<IAuth> & Record<string, unknown>)
  | undefined
 if (!current) return

 authHelper.setAuth({
  ...current,
  organisationId,
 } as never)
}

export const resolveOrganisationId = async (
 userId?: string,
 userData?: Partial<IAuth> | null
): Promise<number | null> => {
 const fromAuth = extractOrganisationId(userData)
 if (fromAuth) return fromAuth

 const fromStorage = extractOrganisationId(
  authHelper.getAuth() as OrgIdSource | undefined
 )
 if (fromStorage) return fromStorage

 if (!userId) return null

 const details = await fetchUserDetails(userId)
 const fromDetails = extractOrganisationId(
  details as OrgIdSource | null
 )

 if (fromDetails) {
  persistOrganisationId(fromDetails)
 }

 return fromDetails
}
